import { render, staticRenderFns } from "./TheItemView.vue?vue&type=template&id=80f67b6e&scoped=true"
import script from "./TheItemView.vue?vue&type=script&lang=js"
export * from "./TheItemView.vue?vue&type=script&lang=js"
import style0 from "./TheItemView.vue?vue&type=style&index=0&id=80f67b6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f67b6e",
  null
  
)

export default component.exports